module.exports = __webpack_public_path__ + "img/GU.6b5b137f.svg";